namespace Matrix.Data {
    export interface DataColumnForm {
        Name: Serenity.StringEditor;
        Title: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        Size: Serenity.IntegerEditor;
        Scale: Serenity.IntegerEditor;
        Visible: Serenity.BooleanEditor;
        DisplayFormat: Serenity.StringEditor;
        Alignment: AlignmentStringEditor;
        Width: Serenity.IntegerEditor;
        FormatterType: Serenity.LookupEditor;
        EditorType: Serenity.LookupEditor;
        FilterOnly: Serenity.BooleanEditor;
        SortOrder: Serenity.IntegerEditor;
        GroupOrder: Serenity.IntegerEditor;
        SummaryType: Serenity.EnumEditor;
    }

    export class DataColumnForm extends Serenity.PrefixedContext {
        static formKey = 'Matrix.Data.DataColumnForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataColumnForm.init)  {
                DataColumnForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = AlignmentStringEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(DataColumnForm, [
                    'Name', w0,
                    'Title', w0,
                    'Type', w1,
                    'Size', w2,
                    'Scale', w2,
                    'Visible', w3,
                    'DisplayFormat', w0,
                    'Alignment', w4,
                    'Width', w2,
                    'FormatterType', w5,
                    'EditorType', w5,
                    'FilterOnly', w3,
                    'SortOrder', w2,
                    'GroupOrder', w2,
                    'SummaryType', w1
                ]);
            }
        }
    }
}
